<script setup>
import { getCurrentInstance, reactive, ref } from "vue";
import Tree from "./tree.vue";
import {
  queryStationInfoByPlantId,
  queryFlowChart,
} from "@/api/stationBaseInfo";
import axios from "axios";

const { proxy } = getCurrentInstance();

const apiUrl = process.env.VUE_APP_OPERATE_URL;

// 弹窗控制
const visible = ref(false);

// 厂站信息
const stationInfo = ref({});
const plantInfo = ref(); // 厂区基础信息
const contracts = ref([]); // 合同信息
const inletInfo = ref({}); // 进水标准信息
const effluentInfo = ref({}); // 出水信息标准信息
const charts = ref([]); // 工艺流程
const safeLicence = ref({}); // 许可证
const urlList = ref([]);
const showViewer = ref(false);
const promotionalImage = ref("");

// 厂站运行状态
const stationStatus = reactive({
  1: "建设中",
  2: "已商运",
});

// 厂站类型
const stationType = reactive({
  1: "城市",
  2: "乡镇",
  3: "工业",
});

const changeImageSrc = (item, type) => {
  item.fileSrc = require(`@/assets/images/file-icon${type}.png`);
};

const openLicence = (type) => {
  // intakeQrUrl 取水许可证
  // hygieneQrUrl 卫生许可证
  // dischargeQrUrl 排污许可证
  urlList.value = safeLicence.value[type] || [];
  showViewer.value = true;
};

// 关闭查看器
const closeViewer = () => {
  showViewer.value = false;
};

// 获取厂站信息
const getStationInfo = (orgId) => {
  queryStationInfoByPlantId(orgId).then((res) => {
    stationInfo.value = res.data;
    inletInfo.value = res.data.opStandardWaterInletDTO;
    axios
      .post(
        "/api/operate/file/preview",
        { reduceUrl: res.data.promotionalImage },
        { responseType: "blob" }
      )
      .then((response) => {
        promotionalImage.value = window.URL.createObjectURL(response.data);
      });
  });
};

const show = (id) => {
  getStationInfo(id);
  getFlowChartList(id);
  // getPlantIdCard(list.id).then((res) => {
  //   const {
  //     plantInfo,
  //     contracts,
  //     inletInfo,
  //     effluentInfo,
  //     charts,
  //     safeLicence,
  //   } = res.data;
  //   contracts.forEach((item) => {
  //     item.fileSrc = require("@/assets/images/statistics/file-icon.png");
  //   });
  //   if (plantInfo.promotionalImageUrl && plantInfo.promotionalImageUrl.length) {
  //     plantInfo.siteImg = this.apiUrl + plantInfo.promotionalImageUrl[0];
  //   } else {
  //     plantInfo.siteImg = "";
  //   }
  //   this.plantInfo = plantInfo;
  //   this.contracts = contracts;
  //   this.inletInfo = inletInfo || {};
  //   this.effluentInfo = effluentInfo || {};
  //   this.charts = charts[0];
  //   this.safeLicence = safeLicence || {};
  //   charts.forEach((item) => {
  //     item.label = item.lable1;
  //   });
  //   this.$refs.flowChartRef.show({ data: charts });
  // });
  // }
  visible.value = true;
};

// 获取工艺流程
const getFlowChartList = (deptId) => {
  queryFlowChart(deptId).then((res) => {
    proxy.$refs.flowChartRef.show(res.data);
  });
};

const getDictName = (dictList, dictValue) => {
  const index = dictList.findIndex((item) => item.dictValue == dictValue);
  return index === -1 ? "" : dictList[index].dictName;
};

defineExpose({
  show,
});
</script>

<template>
  <el-dialog :title="stationInfo.name" width="62.5%" v-model="visible">
    <!-- 基础信息 -->
    <div class="card-item" style="margin-bottom: 32px">
      <el-image class="station-log" :src="promotionalImage" alt="" />
      <div class="station-plant">
        <el-row>
          <el-col :span="12">
            <span class="plant-title">所属厂站：</span>
            <span>{{ stationInfo.name }}</span>
          </el-col>
          <el-col :span="12">
            <span class="plant-title">厂站规模：</span>
            <span>{{ stationInfo.operatingScale }}吨/日</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <span class="plant-title">厂站类别：</span>
            <span>{{ stationType[stationInfo.plantsType] }}</span>
          </el-col>
          <el-col :span="12">
            <span class="plant-title">许可凭证：</span>
            <span
              v-if="safeLicence.needDischarge == 1"
              class="licence"
              @click="openLicence('dischargeQrUrl')"
              >{{ safeLicence.needDischarge == 1 ? "排污许可证" : "" }}</span
            >
            <span
              v-if="safeLicence.needIntake == 1"
              class="licence"
              @click="openLicence('intakeQrUrl')"
              >{{ safeLicence.needIntake == 1 ? "取水许可证" : "" }}</span
            >
            <span
              v-if="safeLicence.needHygiene == 1"
              class="licence"
              @click="openLicence('hygieneQrUrl')"
              >{{ safeLicence.needHygiene == 1 ? "卫生许可证" : "" }}</span
            >
            <span
              class="licence"
              v-if="
                safeLicence.needDischarge != 1 &&
                safeLicence.needIntake != 1 &&
                safeLicence.needHygiene != 1
              "
            >
              暂无许可证
            </span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <span class="plant-title">运行状态：</span>
            <span>{{ stationStatus[stationInfo.plantsStatus] }}</span>
          </el-col>
          <el-col :span="12">
            <span class="plant-title">经纬度：</span>
            <span>{{ stationInfo.lng }} , {{ stationInfo.lat }}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <span class="plant-title">主体处理工艺：</span>
            <span>{{ stationInfo.processingTechnology }}</span>
          </el-col>
          <el-col :span="12">
            <span class="plant-title">水质指标：</span>
            <span>{{ stationInfo.waterStandardName }}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <span class="plant-title">占地面积：</span>
            <span>{{ stationInfo.coversArea }}亩</span>
          </el-col>
          <el-col :span="12">
            <span class="plant-title">是否重点排污单位：</span>
            <span>{{ stationInfo.keyPoint == 1 ? "是" : "否" }}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <span class="plant-title">厂站地址：</span>
            <span>{{ stationInfo.address }}</span>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 合同信息 -->
    <div class="card-item border" style="margin-bottom: 16px">
      <div class="flex-center">
        <img class="tab-img" src="@/assets/images/contract.png" alt="" />
        <span style="margin: 0 8px; line-height: 24px">合同信息</span>
        <el-tooltip
          class="item"
          effect="dark"
          content="展示合同相关信息"
          placement="top-start"
        >
          <i class="el-icon-warning-outline"></i>
        </el-tooltip>
      </div>
      <div style="flex: 1">
        <div
          v-for="(item, index) in contracts"
          :key="item.id"
          :style="index > 0 ? 'border-top:1px solid #ccc' : ''"
        >
          <div class="contracts-top">
            <div class="contracts-title">
              <img
                class="contracts-img"
                src="@/assets/images/image_32.png"
                alt=""
                align="absmiddle"
              />
              <span>{{ item.name }}</span>
            </div>
            <div
              v-if="item.files"
              class="contracts-files"
              @mouseenter="changeImageSrc(item, '-hover')"
              @mouseleave="changeImageSrc(item, '')"
            >
              <img class="file-icon" :src="item.fileSrc" alt="" />
              <span>{{ item.files }}</span>
            </div>
          </div>
          <el-row class="contracts-content">
            <el-col :span="4">
              <div class="contracts-label">商业模式</div>
              <div>{{ item.businessModel }}</div>
            </el-col>
            <el-col :span="3">
              <div class="contracts-label">合同对应期限</div>
              <div>{{ item.effectiveEndTime }}</div>
            </el-col>
            <el-col :span="6">
              <div class="contracts-label">运营起止时间</div>
              <div>
                {{ item.effectiveStartTime + "至" + item.effectiveEndTime }}
              </div>
            </el-col>
            <el-col :span="3">
              <div class="contracts-label">剩余年限（年）</div>
              <div>{{ item.effectiveEndTime }}</div>
            </el-col>
            <el-col :span="4">
              <div class="contracts-label">合同甲方</div>
              <div>{{ item.firstParty }}</div>
            </el-col>
            <el-col :span="4">
              <div class="contracts-label">合作单位</div>
              <div>{{ item.cooperativeUnit }}</div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <!-- 工艺流程 -->
    <div class="card-item border" style="margin-bottom: 16px">
      <div class="flex-center">
        <img class="tab-img" src="@/assets/images/technology.png" alt="" />
        <span style="margin: 0 8px">工艺流程</span>
        <el-tooltip
          class="item"
          effect="dark"
          content="展示工艺流程相关信息"
          placement="top-start"
        >
          <i class="el-icon-warning-outline"></i>
        </el-tooltip>
      </div>
      <div style="flex: 1">
        <Tree ref="flowChartRef" type="view" />
      </div>
    </div>
    <!-- 水质标准 -->
    <div class="card-item border" style="margin-bottom: 16px">
      <div class="flex-center">
        <img class="tab-img" src="@/assets/images/water-quality.png" alt="" />
        <span style="margin: 0 8px">水质标准</span>
      </div>
      <div style="flex: 1">
        <!-- 进水 -->
        <div class="water">
          <img class="water-icon" src="@/assets/images/inflow.png" alt="" />
          <div class="flex1">
            <div class="water-label">COD<sub>cr</sub></div>
            <div>{{ inletInfo.cod || "-" }}</div>
          </div>
          <div class="flex1">
            <div class="water-label">TN</div>
            <div>{{ inletInfo.totalNitrogen || "-" }}</div>
          </div>
          <div class="flex1">
            <div class="water-label">NH<sup>3</sup>-N</div>
            <div>{{ inletInfo.ammoniaNitrogen || "-" }}</div>
          </div>
          <div class="flex1">
            <div class="water-label">TP</div>
            <div>{{ inletInfo.totalPhosphorus || "-" }}</div>
          </div>
          <div class="flex1">
            <div class="water-label">水温</div>
            <div>{{ inletInfo.waterTemperature || "-" }}</div>
          </div>
          <div class="flex1">
            <div class="water-label">PH值</div>
            <div>{{ inletInfo.phStart }}~{{ inletInfo.phEnd }}</div>
          </div>
        </div>
        <div class="line"></div>
        <!-- 出水 -->
        <div class="water">
          <img class="water-icon" src="@/assets/images/effluent.png" alt="" />
          <div class="flex1">
            <div class="water-label">COD<sub>cr</sub></div>
            <div>{{ effluentInfo.cod || "-" }}</div>
          </div>
          <div class="flex1">
            <div class="water-label">BOD<sub>5</sub></div>
            <div>{{ effluentInfo.bod || "-" }}</div>
          </div>
          <div class="flex1">
            <div class="water-label">SS</div>
            <div>{{ effluentInfo.ss || "-" }}</div>
          </div>
          <div class="flex1">
            <div class="water-label">动植物油</div>
            <div>{{ effluentInfo.vegetableOil || "-" }}</div>
          </div>
          <div class="flex1">
            <div class="water-label">石油类</div>
            <div>{{ effluentInfo.oil || "-" }}</div>
          </div>
          <!-- <div class="flex1">
                            <div class="water-label">阴离子表面活性剂</div>
                            <div>{{ effluentInfo.anionicSurfactant || '-' }}</div>
                        </div>
                        <div class="flex1">
                            <div class="water-label">阴离子表面活性剂</div>
                            <div>{{ effluentInfo.anionicSurfactant || '-' }}</div>
                        </div> -->
          <div class="flex1">
            <div class="water-label">TN</div>
            <div>{{ effluentInfo.totalNitrogen || "-" }}</div>
          </div>
          <!-- <div class="flex1">
                            <div class="water-label">NH<sup>3</sup>-N</div>
                            <div>{{ effluentInfo.ammoniaNitrogen || '-' }}</div>
                        </div> -->
          <div class="flex1">
            <div class="water-label">TP</div>
            <div>{{ effluentInfo.totalPhosphorus || "-" }}</div>
          </div>
          <div class="flex1">
            <div class="water-label">色度</div>
            <div>{{ effluentInfo.chroma || "-" }}</div>
          </div>
          <!-- <div class="flex1">
                            <div class="water-label">粪大肠菌群数</div>
                            <div>{{ effluentInfo.fecalColiform || '-' }}</div>
                        </div> -->
          <div class="flex1">
            <div class="water-label">PH值</div>
            <div>{{ effluentInfo.phStart }}~{{ effluentInfo.phEnd }}</div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>

  <el-image-viewer
    v-if="showViewer"
    :on-close="closeViewer"
    :url-list="urlList.map((item) => apiUrl + item)"
  />
</template>

<style lang="scss" scoped>
.card-item {
  display: flex;
}
.station-log {
  width: 250px;
  height: 204px;
  margin-right: 20px;
}
.station-plant {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  background-color: #f6faff;
  border-radius: 4px;
  padding: 16px;
  color: #333333;
}
.plant-title {
  color: #8c8c8c;
  font-size: 14px;
}
.tab-img {
  width: 32px;
  height: 32px;
}
.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 150px;
  background-color: #f8f8f8;
  border-right: 1px solid #d0d3d6;
}

.border {
  border: 1px solid #d0d3d6;
}
.contracts-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .contracts-title {
    height: 33px;
    margin-top: 10px;
    line-height: 33px;
    .contracts-img {
      width: 24px;
      height: 24.91px;
      margin: 0 8px;
    }
  }
  .contracts-files {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    background-color: #f8f8f8;
    height: 24px;
    line-height: 24px;
    border-radius: 0px 3px;
    padding: 0px 6px;
    .file-icon {
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
  }
  .contracts-files:hover {
    color: #3f78f7;
    background-color: #f1f6fe;
  }
}
.contracts-label {
  color: #8c8c8c;
  font-size: 14px;
  margin-bottom: 4px;
}
.contracts-content {
  padding: 8px 38px 12px 38px;
}

.water {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 33px;
  overflow: auto;
  .water-icon {
    width: 100px;
    height: 40px;
    margin-right: 32px;
  }
  .water-label {
    color: #333333;
    font-weight: 600;
    font-size: 14px;
    padding-bottom: 4px;
  }
}
.line {
  margin: 0 33px;
  border-top: 1px dashed #d0d3d6;
}
.flex1 {
  flex: 1;
}
.licence {
  color: #3f78f7;
  margin-right: 10px;
  cursor: pointer;
}
</style>
